import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create async thunk to mark attendance
export const markAttendance = createAsyncThunk(
  'attendance/markAttendance', // Action type
  async (attendanceData, { rejectWithValue }) => {
    try {
      // Make the API request to mark attendance
      const response = await axios.post('/api/attendance', attendanceData);
      return response.data; // Return data if successful
    } catch (error) {
      // Handle error and return the error message using rejectWithValue
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
